// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';

function handleItemChange(event) {

    const rejectReason = this.data.filter(reasonKey => {

        if (reasonKey.key === event.target.value) {

            return reasonKey;

        }
        return '';

    }
      );

    this.onItemChange(rejectReason === '' ? rejectReason : rejectReason[0].value);

}

const Dropdown = ({data, name, onItemChange, text}) => {

    const handleChangeObject = {
        data,
        name,
        onItemChange,
        text
    };

    return (
        <select
            className='select-element'
            onChange={handleChangeObject::handleItemChange}
        >
            {data.map(item =>
                <option
                    key={item.key}
                    value={item.key}
                >
                    {item.value}
                </option>)}
        </select>
    );

};

Dropdown.displayName = 'Dropdown';
Dropdown.propTypes = {
    data: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    name: PropTypes.string.isRequired,
    onItemChange: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/product/transfers/components/dropdown.js